export default __webpack_public_path__ + "static/media/goodWipes-masterImage.92e7fbd4.webp";